import { AuthContainer, VerifyOtp } from '@fhs/auth';

export default function VerifyOtpPage() {
  return (
    <AuthContainer>
      <VerifyOtp />
    </AuthContainer>
  );
}
